"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/taggedTemplateLiteral"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _button = _interopRequireDefault(require("@gravity/button"));
var _heading = _interopRequireDefault(require("@gravity/heading"));
var _stylingConstants = _interopRequireDefault(require("@gravity/styling-constants"));
var _jsxFileName = "/codebuild/output/src3938275692/src/git-codecommit.eu-central-1.amazonaws.com/v1/repos/gravity/apps/tnwi/temp/ui/EmptyState/lib/EmptyState.js",
  _templateObject,
  _templateObject2,
  _templateObject3,
  _templateObject4,
  _templateObject5,
  _templateObject6;
function cov_1m901amnl5() {
  var path = "/codebuild/output/src3938275692/src/git-codecommit.eu-central-1.amazonaws.com/v1/repos/gravity/apps/tnwi/temp/ui/EmptyState/lib/EmptyState.js";
  var hash = "e3872cb5f0643e3070d94e44ebb7d9f4d55eb49b";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/codebuild/output/src3938275692/src/git-codecommit.eu-central-1.amazonaws.com/v1/repos/gravity/apps/tnwi/temp/ui/EmptyState/lib/EmptyState.js",
    statementMap: {
      "0": {
        start: {
          line: 9,
          column: 26
        },
        end: {
          line: 21,
          column: 1
        }
      },
      "1": {
        start: {
          line: 23,
          column: 14
        },
        end: {
          line: 31,
          column: 1
        }
      },
      "2": {
        start: {
          line: 29,
          column: 4
        },
        end: {
          line: 30,
          column: 35
        }
      },
      "3": {
        start: {
          line: 33,
          column: 14
        },
        end: {
          line: 40,
          column: 1
        }
      },
      "4": {
        start: {
          line: 37,
          column: 4
        },
        end: {
          line: 38,
          column: 35
        }
      },
      "5": {
        start: {
          line: 42,
          column: 16
        },
        end: {
          line: 49,
          column: 1
        }
      },
      "6": {
        start: {
          line: 47,
          column: 4
        },
        end: {
          line: 48,
          column: 35
        }
      },
      "7": {
        start: {
          line: 51,
          column: 25
        },
        end: {
          line: 55,
          column: 1
        }
      },
      "8": {
        start: {
          line: 57,
          column: 15
        },
        end: {
          line: 61,
          column: 1
        }
      },
      "9": {
        start: {
          line: 64,
          column: 2
        },
        end: {
          line: 77,
          column: 4
        }
      },
      "10": {
        start: {
          line: 80,
          column: 0
        },
        end: {
          line: 86,
          column: 2
        }
      },
      "11": {
        start: {
          line: 88,
          column: 0
        },
        end: {
          line: 92,
          column: 2
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 28,
            column: 11
          },
          end: {
            line: 28,
            column: 12
          }
        },
        loc: {
          start: {
            line: 29,
            column: 4
          },
          end: {
            line: 30,
            column: 35
          }
        },
        line: 29
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 36,
            column: 11
          },
          end: {
            line: 36,
            column: 12
          }
        },
        loc: {
          start: {
            line: 37,
            column: 4
          },
          end: {
            line: 38,
            column: 35
          }
        },
        line: 37
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 46,
            column: 11
          },
          end: {
            line: 46,
            column: 12
          }
        },
        loc: {
          start: {
            line: 47,
            column: 4
          },
          end: {
            line: 48,
            column: 35
          }
        },
        line: 47
      },
      "3": {
        name: "EmptyState",
        decl: {
          start: {
            line: 63,
            column: 9
          },
          end: {
            line: 63,
            column: 19
          }
        },
        loc: {
          start: {
            line: 63,
            column: 70
          },
          end: {
            line: 78,
            column: 1
          }
        },
        line: 63
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 91,
            column: 17
          },
          end: {
            line: 91,
            column: 18
          }
        },
        loc: {
          start: {
            line: 91,
            column: 23
          },
          end: {
            line: 91,
            column: 25
          }
        },
        line: 91
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 29,
            column: 4
          },
          end: {
            line: 30,
            column: 35
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 29,
            column: 5
          },
          end: {
            line: 29,
            column: 16
          }
        }, {
          start: {
            line: 29,
            column: 20
          },
          end: {
            line: 29,
            column: 42
          }
        }, {
          start: {
            line: 29,
            column: 46
          },
          end: {
            line: 29,
            column: 79
          }
        }, {
          start: {
            line: 30,
            column: 4
          },
          end: {
            line: 30,
            column: 35
          }
        }],
        line: 29
      },
      "1": {
        loc: {
          start: {
            line: 37,
            column: 4
          },
          end: {
            line: 38,
            column: 35
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 37,
            column: 5
          },
          end: {
            line: 37,
            column: 16
          }
        }, {
          start: {
            line: 37,
            column: 20
          },
          end: {
            line: 37,
            column: 42
          }
        }, {
          start: {
            line: 37,
            column: 46
          },
          end: {
            line: 37,
            column: 79
          }
        }, {
          start: {
            line: 38,
            column: 4
          },
          end: {
            line: 38,
            column: 35
          }
        }],
        line: 37
      },
      "2": {
        loc: {
          start: {
            line: 47,
            column: 4
          },
          end: {
            line: 48,
            column: 35
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 47,
            column: 5
          },
          end: {
            line: 47,
            column: 16
          }
        }, {
          start: {
            line: 47,
            column: 20
          },
          end: {
            line: 47,
            column: 42
          }
        }, {
          start: {
            line: 47,
            column: 46
          },
          end: {
            line: 47,
            column: 78
          }
        }, {
          start: {
            line: 48,
            column: 4
          },
          end: {
            line: 48,
            column: 35
          }
        }],
        line: 47
      },
      "3": {
        loc: {
          start: {
            line: 66,
            column: 7
          },
          end: {
            line: 66,
            column: 38
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 66,
            column: 7
          },
          end: {
            line: 66,
            column: 12
          }
        }, {
          start: {
            line: 66,
            column: 16
          },
          end: {
            line: 66,
            column: 38
          }
        }],
        line: 66
      },
      "4": {
        loc: {
          start: {
            line: 69,
            column: 7
          },
          end: {
            line: 75,
            column: 7
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 69,
            column: 7
          },
          end: {
            line: 69,
            column: 13
          }
        }, {
          start: {
            line: 70,
            column: 8
          },
          end: {
            line: 74,
            column: 17
          }
        }],
        line: 69
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0
    },
    b: {
      "0": [0, 0, 0, 0],
      "1": [0, 0, 0, 0],
      "2": [0, 0, 0, 0],
      "3": [0, 0],
      "4": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "e3872cb5f0643e3070d94e44ebb7d9f4d55eb49b"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1m901amnl5 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1m901amnl5();
var EmptyStateWrapper = (cov_1m901amnl5().s[0]++, _styledComponents.default.div.attrs({
  className: 'g-EmptyState'
})(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  position: relative;\n  box-sizing: border-box;\n  text-align: center;\n  background-color: transparent;\n  text-rendering: optimizeLegibility;\n  overflow: hidden;\n  display: block;\n  vertical-align: middle;\n  padding: ", ";\n"])), _stylingConstants.default.spacing.medium));
var Media = (cov_1m901amnl5().s[1]++, _styledComponents.default.div.attrs({
  className: 'g-EmptyState-media'
})(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2.default)(["\n  position: relative;\n  box-sizing: border-box;\n  color: ", ";\n"])), function (props) {
  cov_1m901amnl5().f[0]++;
  cov_1m901amnl5().s[2]++;
  return (cov_1m901amnl5().b[0][0]++, props.theme) && (cov_1m901amnl5().b[0][1]++, props.theme.emptyState) && (cov_1m901amnl5().b[0][2]++, props.theme.emptyState.mediaColor) || (cov_1m901amnl5().b[0][3]++, _stylingConstants.default.color.baseText);
}));
var Title = (cov_1m901amnl5().s[3]++, (0, _styledComponents.default)(_heading.default).attrs({
  className: 'g-EmptyState-title'
})(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2.default)(["\n  color: ", ";\n  background-color: transparent;\n"])), function (props) {
  cov_1m901amnl5().f[1]++;
  cov_1m901amnl5().s[4]++;
  return (cov_1m901amnl5().b[1][0]++, props.theme) && (cov_1m901amnl5().b[1][1]++, props.theme.emptyState) && (cov_1m901amnl5().b[1][2]++, props.theme.emptyState.titleColor) || (cov_1m901amnl5().b[1][3]++, _stylingConstants.default.color.baseText);
}));
var Message = (cov_1m901amnl5().s[5]++, _styledComponents.default.div.attrs({
  className: 'g-EmptyState-message'
})(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2.default)(["\n  font-size: ", ";\n  color: ", ";\n"])), _stylingConstants.default.font.sizeS, function (props) {
  cov_1m901amnl5().f[2]++;
  cov_1m901amnl5().s[6]++;
  return (cov_1m901amnl5().b[2][0]++, props.theme) && (cov_1m901amnl5().b[2][1]++, props.theme.emptyState) && (cov_1m901amnl5().b[2][2]++, props.theme.emptyState.textColor) || (cov_1m901amnl5().b[2][3]++, _stylingConstants.default.color.baseText);
}));
var EmptyStateButton = (cov_1m901amnl5().s[7]++, (0, _styledComponents.default)(_button.default).attrs({})(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteral2.default)(["\n  margin-right: 0;\n  margin-bottom: 0;\n"]))));
var Action = (cov_1m901amnl5().s[8]++, _styledComponents.default.div.attrs({
  className: 'g-EmptyState-action'
})(_templateObject6 || (_templateObject6 = (0, _taggedTemplateLiteral2.default)(["\n  padding: ", ";\n"])), _stylingConstants.default.spacing.medium));
function EmptyState(_ref) {
  var media = _ref.media,
    title = _ref.title,
    message = _ref.message,
    action = _ref.action,
    onActionClick = _ref.onActionClick;
  cov_1m901amnl5().f[3]++;
  cov_1m901amnl5().s[9]++;
  return /*#__PURE__*/_react.default.createElement(EmptyStateWrapper, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 65,
      columnNumber: 5
    }
  }, (cov_1m901amnl5().b[3][0]++, media) && (cov_1m901amnl5().b[3][1]++, /*#__PURE__*/_react.default.createElement(Media, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 66,
      columnNumber: 17
    }
  }, media)), /*#__PURE__*/_react.default.createElement(Title, {
    level: 3,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 67,
      columnNumber: 7
    }
  }, title), /*#__PURE__*/_react.default.createElement(Message, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 68,
      columnNumber: 7
    }
  }, message), (cov_1m901amnl5().b[4][0]++, action) && (cov_1m901amnl5().b[4][1]++, /*#__PURE__*/_react.default.createElement(Action, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 70,
      columnNumber: 9
    }
  }, /*#__PURE__*/_react.default.createElement(EmptyStateButton, {
    neutral: true,
    onClick: onActionClick,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 71,
      columnNumber: 11
    }
  }, action))));
}
cov_1m901amnl5().s[10]++;
EmptyState.propTypes = {
  media: _propTypes.default.node,
  title: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.node]).isRequired,
  message: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.node]).isRequired,
  action: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.node]),
  onActionClick: _propTypes.default.func
};
cov_1m901amnl5().s[11]++;
EmptyState.defaultProps = {
  media: null,
  action: null,
  onActionClick: function onActionClick() {
    cov_1m901amnl5().f[4]++;
  }
};
var _default = exports.default = EmptyState;